export default __webpack_public_path__ + "static/media/SectionCard_Careers.7eaa1d63.jpg";